<style>
</style>
<template>
  <div class="container-fluid">
    <div class="card animated fadeIn" v-if="!loading">
      <b-form @submit.prevent="addAccount()">
        <b-row>
          <b-col sm=8>
            <b-card>
              <div slot="header">
                <strong>Add Account:</strong>
              </div>
              <div>
                <div>
                  <div>
                    <b-form-group label="Name:" label-for="name" :label-cols-sm="2">
                      <b-form-input type="text" v-model="account.name" v-validate="'required'" id="name" name="name" :state="validateState('name')"></b-form-input>
                      <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                    </b-form-group>
                    <b-form-group label="Token:" label-for="name" :label-cols-sm="2">
                      <b-form-input type="text" v-model="account.token" readonly></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col sm=4>
            <b-card>
              <div slot="header">
                <strong>Details</strong>
              </div>
              Info goes here
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=8>
            <div class="text-center">
              <!-- TODO only activate when dirty -->
              <button :disabled="verrors.any()" class="btn btn-primary">Save</button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {
  vm
}
from '@/app.js'

export default {
  components: {

    Multiselect,
  },
  data() {

    return {
      account: {},
      submitted: false,
      account_opts: [],
      role_opts: [],
      sel_role_opts: [],
      selectedAccounts: [],
      selectedRoles: [],
      selectedIds: [],
      value: [],
      loading: 'false',


    };

  },
  // https://github.com/shentao/vue-multiselect/issues/263
  watch: {
    value(newValues) {
      this.selectedIds = newValues.map(obj => obj.id);
    }
  },


  created() {
    this.loading = true;
    let uri = `/api/accounts/create`;
    axios.get(uri).then((response) => {
      this.account.token = response.data.data.token;
      this.loading = false;
    });



  },
  computed: {
    optionsArray() {
      return Object.keys(this.options).map(i => this.options[i]);
    }
  },


  methods: {
    // toArray(obj_obj) {
    //   return Object.keys(obj_obj).map(i => obj_obj[i]);
    // },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.verrors.has(ref)
      }
      return null
    },


    addAccount() {
      this.submitted = true;
      this.account.role_list = this.selectedIds;
      this.$validator.validate().then(valid => {
        if (valid) {
          let uri = `/api/accounts/`;
          axios.post(uri, this.account).then((response) => {

              if (response.data.success === true) {
                console.log(response.data);
                this.makeToast('info', 'Account added.');
                setTimeout(function() {
                  window.location.href = '/#/accounts';
                }, 1000);

              } else {
                console.log(error.response.data.message);
                this.makeToast('danger', 'Unable to update account.');
              }
            })
            .catch(function(error) {
              if (error.response && error.response.status == 422) {
                vm.$setErrorsFromResponse(error.response.data);
              }
            });

        }
      });
    },
    makeToast(variant = null, message = null) {

      this.$bvToast.toast(message, {
        // title: `Config Updated ${variant || 'default'}`,
        title: `Notification:`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true
      });
      // toast.show();
    },
  }

}
</script>
